/* ExportAction.js */

"use strict";
const _ = require("lodash");
const FileName = require("@gluenetworks/steve_utilities").fileName;

class ExportAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        SiteEntity,
        userSession,
        activeView,
        steveIo
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._SiteEntity = SiteEntity;

        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._steveIo = steveIo;
        this._fileNamer = FileName;
        this._activeOrgId = userSession.activeOrganization.id;
        this.run = this.run.bind(this);
    }

    run() {
        let entityIds = this._activeView.getSelectedSiteIds().selectedRows;

        if (_.isEmpty(entityIds)) {
            return Promise.resolve();
        }

        const workTarget = {
            method: "query",
            category: "entity",
            entityType: "Site",
            query: {id: {$in: entityIds}},
        };
        const workInput = {
            reportName: "siteReport",
            reportDescription: "Sites",
        };
        let report;

        return this._SiteEntity
            .runWork(this._activeOrgId, "entityReport", workTarget, workInput, {
                reportOnly: true,
            })
            .then((result) => {
                report = result;

                if (result.errorMsg) {
                    return Promise.reject(result.errorMsg);
                }

                if (entityIds.length === 1) {
                    return this._SiteEntity.loadSite(this._activeOrgId, entityIds[0], {name: true});
                }
                return Promise.resolve();
            })
            .then((ety) => {
                let specificPart = "MultipleSites";
                if (ety) {
                    specificPart = ety.name;
                }
                const fileName = this._fileNamer({
                    solution: "DM",
                    general: "Site",
                    specific: specificPart,
                    suffix: "csv",
                });

                let file = new this._steveIo.File(fileName, null, report.contents);
                this._steveIo.fileFactory.saveFile(file);
                return Promise.resolve();
            })
            .catch((err) => {
                this._logger.warn("Site Export Error :: ", err);
            });
    }
}

module.exports = ExportAction;

ExportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Site",
    "$teve.userSession",
    "gameEditor.activeView",
    "$teve.io",
];

ExportAction.$displayDetails = {
    type: "Action",
    name: "ExportAction",
    icon: "configdrift.export_devices",
    shown: true,
    title: "Export sites",
    order: 12,
};
